import { render, staticRenderFns } from "./Tema5.vue?vue&type=template&id=417b0c4f&lang=pug"
import script from "./Tema5.vue?vue&type=script&lang=js"
export * from "./Tema5.vue?vue&type=script&lang=js"
import style0 from "./Tema5.vue?vue&type=style&index=0&id=417b0c4f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports